<div class="sidePanel scrubberCalcSide_Panel">
    <div *ngIf="viewDetailsSidePanel">
        <div class="totalPool">
            <span class="section-title totalPoolslength">{{storeSidePanelData?.length}} pool(s): </span>
            <div class="poolName">
                <span class="body-b1">{{formattedPoolNames}}</span>
            </div>
        </div>
        <div class="totalSidePanelData">
            <ul class="info-list">
                <li>
                    <div class="section-title">Total scrubber savings</div>
                    <span class="section-title valueScrubberCalc color__primary">
                        {{(toggleVal === 'YTD' ? calculationResponse[0]?.scrubberSavings : calculationResponse[0]?.scrubberSavingsMonthly) |
                        negativeToBracket: true}} </span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [totalScrubberSavings]="true"
                            [bunkerConsMultiLSF]="sidePanelScrubberData?.bunkerConsumptionMultipliers[0]?.LSF"
                            [bunkerConsMultiMGO]="sidePanelScrubberData?.bunkerConsumptionMultipliers[0]?.MGO">
                        </app-static-data>
                    </div>
                    <div class="body-b3">
                        <p class="right-align">
                            {{(toggleVal === 'YTD' ? calculationResponse[0]?.totalIFOConsumptionYTD : calculationResponse[0]?.totalIFOConsumption) | negativeToBracket}} MT
                        </p>
                        <p class="right-align">
                            x [({{sidePanelScrubberData?.bunkerConsumptionMultipliers[0]?.LSF}} x
                            {{sidePanelScrubberData?.avgBunkerPriceMonthly[0]?.LSF | negativeToBracket: true}})
                        </p>
                        <p class="right-align">
                            + ({{sidePanelScrubberData?.bunkerConsumptionMultipliers[0]?.MGO}} x
                            {{sidePanelScrubberData?.avgBunkerPriceMonthly[0]?.MGO | negativeToBracket: true}})]
                        </p>
                        <p class="right-align">
                            - {{(toggleVal === 'YTD' ? calculationResponse[0]?.totalIFOCostYTD : calculationResponse[0]?.totalIFOCost) | negativeToBracket: true}}
                        </p>
                    </div>
                </li>
            </ul>
            <div class="hr-div">
                <div class="line"></div>
            </div>
            <ul class="info-list">
                <li>
                    <div class="section-title">Total IFO consumption</div>
                    <span class="section-title valueScrubberCalc color__primary">
                        {{(toggleVal === 'YTD' ? calculationResponse[0]?.totalIFOConsumptionYTD : calculationResponse[0]?.totalIFOConsumption) | negativeToBracket}} MT
                    </span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [totalIfoConsumptionSidePanel]="true"> </app-static-data>
                    </div>
                    <div class="body-b3">
                        <p class="right-align">
                            {{ (toggleVal === 'YTD' ? calculationResponse[0]?.IFOConsumptionOfPoolYTD : calculationResponse[0]?.IFOConsumptionOfPool) | negativeToBracket}} MT
                        </p>
                        <p class="right-align">
                            - {{calculationResponse[0]?.prevYearIFOConsumptionOfPoolYTD | negativeToBracket}} MT
                        </p>
                    </div>
                </li>
            </ul>
            <div class="hr-div">
                <div class="line"></div>
            </div>
            <ul class="info-list">
                <li>
                    <div class="section-title">Total IFO cost</div>
                    <span class="section-title valueScrubberCalc color__primary">
                        {{(toggleVal === 'YTD' ? calculationResponse[0]?.totalIFOCostYTD : calculationResponse[0]?.totalIFOCost) | negativeToBracket: true }} 
                    </span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [totalIfoCost]="true"> </app-static-data>
                    </div>
                    <div class="body-b3">
                        <p class="right-align">
                            {{(toggleVal === 'YTD' ? calculationResponse[0]?.IFOCostOfPoolYTD : calculationResponse[0]?.IFOCostOfPool) | negativeToBracket: true }}
                        </p>
                        <p class="right-align">
                            - {{calculationResponse[0]?.prevYearIFOCostOfPoolYTD | negativeToBracket: true}}
                        </p>
                    </div>
                </li>
            </ul>
            <div class="hr-div">
                <div class="line"></div>
            </div>
        </div>
        <ul>
            <li *ngFor="let items of storeSidePanelData">
                <snl-accordion [showArrow]="showArrow" [showBorder]="showBorder" [isTitleClickable]="isTitleClickable"
                    [expanded]="expanded" [id]="accordionId" [settings]="accordionSettings"
                    [ngClass]="expanded ? '' : 'collapsed'">
                    <div header-content>Pool {{items?.poolName}}</div>
                    <ul class="info-list">
                        <li>
                            <span class="body-b label-color">{{items?.sidePanelScrubberName}}</span>
                            <span class="section-title valueScrubberCalc color__primary">
                                {{(toggleVal === 'YTD' ? items?.scrubberSavings : items?.scrubberSavingsMonthly) | negativeToBracket: true }}
                            </span>
                        </li>
                    </ul>
                    <ul class="info-list">
                        <li>
                            <span class="body-b label-color">{{items?.sidePanelIFOConsumption}}</span>
                            <span class="section-title valueScrubberCalc color__primary">
                                {{(toggleVal === 'YTD' ? items?.IFOConsumptionOfPoolYTD : items?.IFOConsumptionOfPool) | negativeToBracket}} MT
                            </span>
                        </li>
                    </ul>
                    <ul class="info-list">
                        <li>
                            <span class="body-b label-color">{{items?.sidePanelPYIFOConsumption}}</span>
                            <span class="section-title valueScrubberCalc color__primary">{{items?.prevYearIFOConsumptionOfPoolYTD | negativeToBracket }} MT</span>
                        </li>
                    </ul>
                    <ul class="info-list">
                        <li>
                            <span class="body-b label-color">{{items?.sidePanelIFOCost}}</span>
                            <span class="section-title valueScrubberCalc color__primary">
                                {{(toggleVal === 'YTD' ? items?.IFOCostOfPoolYTD : items?.IFOCostOfPool) | negativeToBracket: true}}
                            </span>
                        </li>
                    </ul>
                    <ul class="info-list">
                        <li>
                            <span class="body-b label-color">{{items?.sidePanelPYIFOCost}}</span>
                            <span class="section-title valueScrubberCalc color__primary">{{items?.prevYearIFOCostOfPoolYTD | negativeToBracket: true}}</span>
                        </li>
                    </ul>

                </snl-accordion>
            </li>
        </ul>
    </div>
    <div *ngIf="shipSidePanel">
        <div class="totalSidePanelData shipSidepanel">
            <ul class="info-list">
                <li>
                    <div class="section-title">Scrubber savings</div>
                    <span class="section-title valueScrubberCalc color__primary">
                        {{ (toggleVal === 'YTD' ? sidePanelScrubberShipData?.data[0]?.scbrSavingsAmtYTD :
                        sidePanelScrubberShipData?.data[0]?.scbrSavingsAmt) | negativeToBracket: true }}
                    </span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [scrubberSavings]="true" >  </app-static-data>
                    </div>
                    <div class="body-b3">
                        <p class="right-align">
                        {{ (toggleVal === 'YTD' ? sidePanelScrubberShipData?.data[0].scbrDaysYTD : sidePanelScrubberShipData?.data[0].scbrDays) | negativeToBracket }} x {{(sidePanelScrubberShipData?.data[0].scbrPoints | negativeToBracket)}}
                        </p>
                        <hr>
                        <p class="right-align">
                            {{ (toggleVal === 'YTD' ? sidePanelScrubberShipData?.data[0].distributionWeightYTD : sidePanelScrubberShipData?.data[0].distributionWeight) | negativeToBracket }}
                        </p>      
                        <p class="right-align">
                            x {{ (toggleVal === 'YTD' ? sidePanelScrubberShipData?.data[0].yearlyTotalScrubberSavingsOfFleet : sidePanelScrubberShipData?.data[0].monthlyTotalScrubberSavingsOfFleet) | negativeToBracket }}
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>